import { AfterViewInit, OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin, of, Subject } from 'rxjs';
import { BriefComment } from 'src/app/models/brief-comment.model';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { JobItem } from 'src/app/models/job-item.model';
import { UserContactInfo } from 'src/app/models/user-contact-info.model';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { JobService } from 'src/app/services/sections/job/job.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';

@Component({
	templateUrl: './note-thread.component.html',
	styleUrls: ['./note-thread.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss']
})
export class NoteThreadComponent implements OnInit, OnDestroy, AfterViewInit {

	public readonly PageType = PageType;
	public readonly ButtonIcons = ButtonIcons;
	public readonly ActionsPlaceholderSettings = ActionsPlaceholderSettings;
	public pageType: PageType;
	public customerPreferences: SettingsPreferences;
	public moment = moment;

	public formModel: FormGroup = new FormGroup({
		selectedJob: new FormControl(null)
	});

	public isLoading = false;

	public routePayload: { staffMembers: UserContactInfo[], jobs: JobItem[] } = {
		staffMembers: [],
		jobs: []
	};
	public comments: BriefComment[] = [];

	public unsubscriber$ = new Subject<void>();

	public self = this;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private jobService: JobService
	) { }

	ngOnInit(): void {

		this.routePayload = this.activatedRoute.snapshot.data.noteThread || { staffMembers: [], jobs: [] };
		this.customerPreferences = this.activatedRoute.snapshot.data.customerPreferences as SettingsPreferences;
		this.pageType = this.activatedRoute.snapshot.data.pageType;

		this.formModel.get('selectedJob').valueChanges
			.subscribe(newValue => {
				GlobalSettingsService.isSecondaryLoaderLoading = true;
				this.jobService.getJobNoteThread(TokenHelper.getToken(this.activatedRoute), newValue.id)
					.subscribe(data => {
						this.comments = data;

						this.comments.forEach(item => {
							item.isWrittenByStaff = !!this.routePayload.staffMembers?.find(member => member.userAccountId === item.createdBy);
						});

						GlobalSettingsService.isSecondaryLoaderLoading = false;
					});
			});

		this.formModel.get('selectedJob').setValue(this.routePayload.jobs?.find(item => item.isCurrentJob));
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}

	public reply(note: BriefComment): void {
		this.router.navigate([`/${TokenHelper.getToken(this.activatedRoute)}/job/collaborate`], { queryParams: { recipient: note.createdBy } });
	}
}
